/* THEROIR VI - language switcher.
   Replaces the native select language picker (whose OS popup renders too narrow
   and overlaps page content) with a compact EN / FR toggle.
   The original select stays in the DOM (visually hidden via CSS) so the Shopify
   localization form still submits language_code exactly as before. */
(function () {
  var LABELS = { en: 'EN', fr: 'FR' };
  window.__theroirLang = { loaded: true, runs: 0, built: 0 };

  function build(select) {
    if (!select || select.dataset.theroirLang) return;
    select.dataset.theroirLang = '1';

    var form = select.closest('form');
    var group = document.createElement('div');
    group.className = 'theroir-lang';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', select.getAttribute('aria-label') || 'Language');

    Array.prototype.forEach.call(select.options, function (option, index) {
      if (index > 0) {
        var sep = document.createElement('span');
        sep.className = 'theroir-lang__sep';
        sep.setAttribute('aria-hidden', 'true');
        sep.textContent = '/';
        group.appendChild(sep);
      }

      var code = String(option.value || '').toLowerCase();
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'theroir-lang__btn';
      button.lang = option.value;
      button.textContent = LABELS[code] || code.slice(0, 2).toUpperCase();
      button.title = (option.textContent || '').trim();
      if (option.selected) button.setAttribute('aria-current', 'true');

      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (option.selected) return;
        select.value = option.value;
        if (form) form.submit();
      });

      group.appendChild(button);
    });

    if (select.parentNode) {
      select.parentNode.insertBefore(group, select);
      window.__theroirLang.built++;
    }
  }

  function init() {
    window.__theroirLang.runs++;
    var selects = document.querySelectorAll('select.localization-form__select');
    Array.prototype.forEach.call(selects, build);
  }

  init();
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('page:loaded', init);

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      if (document.querySelector('select.localization-form__select:not([data-theroir-lang])')) init();
    });
    if (document.documentElement) {
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }
})();
